<template>
  <v-card style="width: 80%; margin: auto; margin-top: 2rem;">
    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="fullname" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Company Name : </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search by name" single-line outlined
            hide-details dense></v-text-field>

          <v-spacer></v-spacer>
          <!--  @click="openadd()" -->
          <v-btn color="#0A7EA5" rounded dark :disabled="!authorize_add" style="margin: auto;" @click="openAddCom()">
            <!-- :disabled="!authorize_add" -->
            Add company
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- ปุ่ม edit ของบริษัทอื่น: EditCompanyDialog หน้าเดียว (Company information + Billing) -->
        <v-icon small class="mr-2" color="#2a7f86" @click="openEditBasic(item)"
          v-if="authorize_edit && !isMasterCompany">
          mdi-pencil-box-outline
        </v-icon>
        <!-- ⭐ ปุ่ม edit ใหม่: เห็นเฉพาะ user ของ company 1 (แก้ข้อมูล + เมนูของบริษัทนั้น) -->
        <v-icon small class="mr-2" color="#2a7f86" @click="openEditNew(item)" v-if="authorize_edit && isMasterCompany">
          mdi-pencil-box-outline
        </v-icon>
        <!-- <v-icon small @click="deleteItem(item)" v-if="authorize_del">
          mdi-delete
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getcompanydata">
          Reset
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogadd" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">Add company</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="itemadd.code" label="Company code" outlined hide-details dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="itemadd.name" label="Company Name(EN)" outlined hide-details
                  dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="itemadd.name_th" label="Company Name(TH)" outlined hide-details
                  dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="itemadd.invoice_address" label="Invoice Address" outlined hide-details
                  dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemadd.tax_id" label="Tax ID" outlined hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemadd.branch" label="Branch" outlined hide-details dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemadd.email" label="Email" outlined hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemadd.tel" label="Tel" outlined hide-details dense></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select v-validate="'required'" :items="statusall" label="Status" item-text="cgm_name" item-value="id"
                  v-model="itemadd.status" outlined required hide-details dense></v-select>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
              <v-file-input
                :rules="rules"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Pick an Image"
                prepend-icon="mdi-camera"
                label="Image"
                v-model="itemadd.image"
                outlined
                hide-details
                dense
              ></v-file-input>
            </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="canceladd()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="savedata()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AddCompanyDialog v-model="dialogAddCom" :disabled-status="disabled_status" @alert="onDialogAlert"
      @saved="getcompanydata" />
    <!-- ⭐ company 1: แก้ไขแบบ step (Company information / Billing / Menu access) -->
    <AddCompanyDialog v-model="dialogEditCom" mode="edit" :company="editCompany" :disabled-status="disabled_status"
      @alert="onDialogAlert" @saved="getcompanydata" />
    <!-- ⭐ บริษัทอื่น: แก้ไขหน้าเดียว (Company information + Billing) -->
    <EditCompanyDialog v-model="dialogEditBasic" :company="editCompany" :disabled-status="disabled_status"
      @alert="onDialogAlert" @saved="getcompanydata" />
    <v-dialog v-model="dialogedit" max-width="900px">
      <v-form @submit.prevent="savedataedit" ref="form">
        <v-card>
          <v-card-title class="text-h5">Edit company</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <span style="font-size: 18px; font-weight: bold;">Company Information</span>
                  <span style="font-size: 18px; font-weight: bold; color: red;">
                    *</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field v-model="itemedit.name" outlined dense label="Company Name"
                    ref="Company_Name"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="12" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.company_address" outlined dense label="Company Address"
                    ref="Company_Address"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="12" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.company_address2" outlined dense label="Address2"
                    ref="company_edit_address2"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.subdistrict" outlined dense label="Sub-district"
                    ref="edit_subdistrict"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.district" outlined dense label="District"
                    ref="edit_district"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.province" outlined dense label="Province"
                    ref="edit_province"></v-text-field>
                </v-col>
              </v-row>

              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.postcode" outlined dense label="Postcode"
                    ref="edit_postcode"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.country" outlined dense label="Country"
                    ref="edit_country"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="itemedit.company_branch" outlined dense label="Branch"
                    ref="Company_Branch"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.company_email" outlined dense label="Company Email"
                    ref="Company_Email" :rules="emailRules"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.company_tel" outlined dense label="Telephone Number"
                    ref="Company_Telephone_Number" :rules="telRules"></v-text-field>
                </v-col>
                <v-col cols="10" md="3">
                  <v-text-field v-model="itemedit.code" outlined dense label="Company Code" ref="Company_Code"
                    :counter="6" :rules="comcodeRules"></v-text-field>
                </v-col>
                <v-col cols="2" md="1" class="mt-1">
                  <v-tooltip bottom max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="blue" v-bind="attrs" v-on="on" dark class="custom-icon">mdi-help-circle</v-icon>
                    </template>
                    <!-- <v-card > -->
                    <v-card-title class="headline">
                      <span style="
                            font-size: 18px;
                            font-weight: bold;
                        ">
                        Company Code
                      </span>
                    </v-card-title>

                    <v-card-text>
                      Your company code must be a maximum of 6 digits. This code
                      will be used to identify employees of your company during
                      the login process. Ensure that the code is unique and
                      easily recognizable for your organization.
                    </v-card-text>

                    <!-- </v-card> -->
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <span style="font-size: 18px; font-weight: bold;">Invoice Information</span>
                  <span style="font-size: 18px; font-weight: bold; color: red;">
                    *</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <label>
                    <input type="checkbox" v-model="checkSameComInv" /> Same as
                    Company Information
                  </label>
                </v-col>
              </v-row>

              <v-row style="margin-top: -10px;">
                <v-col cols="12" md="12">
                  <v-text-field v-model="itemedit.inv_company_name" outlined dense label="Company Name"
                    ref="INV_Company_Name"></v-text-field>
                </v-col>
              </v-row>

              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="12">
                  <v-text-field v-model="itemedit.inv_company_name_th" outlined dense label="Company Name Thai"
                    ref="INV_Company_Name_TH"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="12" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_company_address" outlined dense label="Invoice Address"
                    ref="Invoice_Address"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="12" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_company_address2" outlined dense label="Invoice Address2"
                    ref="edit_inv_company_address2"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_subdistrict" outlined dense label="Sub-district"
                    ref="edit_inv_subdistrict"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_district" outlined dense label="District"
                    ref="edit_inv_district"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_province" outlined dense label="Province"
                    ref="edit_inv_province"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_postcode" outlined dense label="Postcode"
                    ref="edit_inv_postcode"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_country" outlined dense label="Country"
                    ref="edit_inv_country"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_company_branch" outlined dense label="Branch"
                    ref="INV_Branch"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <v-text-field v-model="itemedit.inv_company_email" outlined dense label="Company Email"
                    ref="INV_Email" :rules="emailRules"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <!-- :rules="telRules" -->
                  <v-text-field v-model="itemedit.inv_company_tel" outlined dense label="Telephone Number"
                    ref="INV_Telephone_Number"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="responsive-marginCol">
                  <!-- :rules="numberRules" -->
                  <v-text-field v-model="itemedit.inv_tax_id" outlined dense label="Tax ID"
                    ref="INV_Tax_ID"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -30px;">
                <v-col cols="12" sm="4" class="responsive-marginCol">
                  <v-select v-validate="'required'" :items="statusall" label="Status" item-text="cgm_name"
                    item-value="id" v-model="itemedit.status" outlined required :disabled="disabled_status" hide-details
                    dense></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <span style="font-size: 18px; font-weight: bold;">Employee Settings</span>
                  <span style="font-size: 18px; font-weight: bold; color: red;">
                    *</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" class="responsive-marginCol">
                  <v-select v-model="itemdocedit.doc_status" v-validate="'required'" :items="emp_assign"
                    label="Assign Employee ID" item-text="name" item-value="values" outlined required
                    :disabled="disabled_status" hide-details dense></v-select>
                </v-col>
                <v-col cols="12" md="2" class="responsive-marginCol" v-if="itemdocedit.doc_status == 0">
                  <v-text-field v-model="itemdocedit.id_prefix" outlined dense label="Prefix"
                    ref="Prefix"></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="responsive-marginCol" v-if="itemdocedit.doc_status == 0">
                  <v-text-field v-model="itemdocedit.running_len" outlined dense label="Range" ref="Range Edit"
                    type="number"></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="responsive-marginCol" v-if="itemdocedit.doc_status == 0">
                  <v-text-field v-model="itemdocedit.running_next" outlined dense label="Next Running"
                    ref="Next Running Edit" type="number"></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-validate="'required'"
                  :items="statusall"
                  label="Status"
                  item-text="cgm_name"
                  item-value="id"
                  v-model="itemedit.status"
                  outlined
                  required
                  :disabled="disabled_status"
                  hide-details
                  dense
                ></v-select>
              </v-col>
            </v-row> -->

              <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-file-input
                  :rules="rules"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="Pick an Image"
                  prepend-icon="mdi-camera"
                  label="Image"
                  v-model="itemedit.image"
                  outlined
                  hide-details
                  dense
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-img
                  :lazy-src="image_link"
                  max-height="250"
                  max-width="250"
                  :src="image_link"
                  contain
                ></v-img>
              </v-col>
            </v-row>
           -->
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="canceledit()">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="savedataedit()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
  </v-card>
</template>
<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import { provide } from "vue";
// ⭐ ใหม่: ดึงรายการ group menu ของบริษัทต้นแบบ (Master Template) มาแสดงเป็น checkbox
import { getRegisterCompanyMasterTemplate } from "@/services/api-dtime/api_register_company";
import AddCompanyDialog from "./AddCompanyDialog.vue";
import EditCompanyDialog from "./EditCompanyDialog.vue";
export default {
  components: {
    SuccessDialog,
    AddCompanyDialog,
    EditCompanyDialog,
  },
  data: () => ({
    rules: [
      (value) =>
        !value ||
        value.size < 2000000 ||
        "Image size should be less than 2 MB!",
    ],
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    search: "",
    dialogadd: false,
    dialogedit: false,
    dialogAddCom: false,
    dialogEditCom: false,
    dialogEditBasic: false,
    editCompany: null,
    headers: [
      { text: "ID", value: "id" },
      { text: "Code", value: "code" },
      { text: "Name", value: "name" },
      // { text: "address", value: "address" },
      // { text: "provice", value: "provice" },
      // { text: "zipcode", value: "zipcode" },
      { text: "Status", value: "status" },
      { text: "Action", value: "actions" },
    ],
    desserts: [],
    itemadd: {
      code: "",
      name: "",
      company_address: "",
      company_branch: "",
      company_email: "",
      company_tel: "",
      inv_company_name: "",
      inv_company_name_th: "",
      inv_company_address: "",
      inv_company_branch: "",
      inv_company_email: "",
      inv_company_tel: "",
      inv_tax_id: "",
      status: "",
      image: null,
    },
    itemeditid: 0,
    itemedit: {
      code: "",
      name: "",
      company_address: "",
      company_branch: "",
      company_email: "",
      company_tel: "",
      inv_company_name: "",
      inv_company_name_th: "",
      inv_company_address: "",
      inv_company_branch: "",
      inv_company_email: "",
      inv_company_tel: "",
      inv_tax_id: "",
      status: "",
      image: null,
      company_address2: "",
      subdistrict: "",
      district: "",
      province: "",
      postcode: "",
      country: "",
      inv_company_address2: "",
      inv_subdistrict: "",
      inv_district: "",
      inv_province: "",
      inv_postcode: "",
      inv_country: "",
    },
    itemdocedit: {
      module: "Employee",
      id_prefix: "",
      running_year: new Date()
        .getFullYear()
        .toString()
        .slice(-2),
      running_len: 1,
      running_next: 1,
      doc_status: 0,
    },
    User_Telephone_Number: "",
    itemAddCom: {
      code: "",
      name: "",
      company_address: "",
      company_address2: "",
      subdistrict: "",
      district: "",
      province: "",
      postcode: "",
      country: "",
      company_branch: "",
      company_email: "",
      company_tel: "",
      inv_company_name: "",
      inv_company_name_th: "",
      inv_company_address: "",
      inv_company_address1: "",
      inv_company_address2: "",
      inv_subdistrict: "",
      inv_district: "",
      inv_province: "",
      inv_postcode: "",
      inv_country: "",
      inv_company_branch: "",
      inv_company_email: "",
      inv_company_tel: "",
      inv_tax_id: "",
      status: "ACTIVE",
      image: null,
      module: "Employee",
      id_prefix: "",
      running_year: new Date()
        .getFullYear()
        .toString()
        .slice(-2),
      running_len: 1,
      running_next: 1,
      doc_status: 0,
    },
    statusall: ["ACTIVE", "INACTIVE"],
    emp_assign: [
      { name: "Manual", values: 1 },
      { name: "Auto-generated", values: 0 },
    ],
    disabled_status: false,
    image_link: "",
    checkSameComInv: false,
    checkSameComInvAdd: false,
    numberRules: [
      (v) => !v || /^[0-9]+$/.test(v) || "Please Input Number Only",
    ],
    telRules: [
      (v) => !v || /^[+]?([0-9,-]+)$/.test(v) || "Please Input Number Only",
    ],
    emailRules: [
      (v) =>
        !v ||
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v,
        ) ||
        "Please enter a valid email address",
    ],
    comcodeRules: [
      (v) => (!v || v.length > 6 ? "Please check that the Company Code" : true),
    ],
    isShowPassword: false,
    isShowPassconfirmword: false,
    Firstname: "",
    Lastname: "",
    Email: "",
    Username: "",
    Password: "",
    Confirm_Password: "",
    // ⭐ ใหม่: รายการ group menu ของบริษัทต้นแบบ + กลุ่มที่ผู้ใช้เลือกไว้
    masterGroupMenus: [],
    selectedGroupMenuIds: [],
    phoneRules: [
      (v) => !!v || "Phone number is required",
      (v) => /^[0-9]*$/.test(v) || "Numbers only",
      (v) => (v && v.length <= 10) || "Max 10 digits",
    ],
  }),
  async mounted() {
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (localStorage.getItem(server.ROLE) != "ADMIN") {
      this.authorize_add = false;
      this.disabled_status = true;
    }

    if (!this.authorize_view) {
      // console.log("res_auth:" + JSON.stringify(res_auth.data));
      // console.log("authorize_view:" + this.authorize_view);
      // console.log("authorize_add:" + this.authorize_add);
      // console.log("authorize_edit:" + this.authorize_edit);
      // console.log("authorize_del:" + this.authorize_del);
      // this.$router.back();

      this.$router.back();
    }

    // ----------------- Check Authorize ---------------------------

    let token = localStorage.getItem(server.USER_ID);

    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    await this.getcompanydata();
    await this.loadMasterGroupMenus();
  },
  computed: {
    // user ที่ login อยู่ในบริษัทต้นแบบ (company_id = 1) หรือไม่
    isMasterCompany() {
      return String(localStorage.getItem(server.COMPANYID)) === "1";
    },
    // ⭐ ใหม่: checkbox "เลือกทั้งหมด" ของ Menu Template
    // get: ติ๊กเมื่อเลือกครบทุกกลุ่ม, set: ติ๊ก/ไม่ติ๊ก ก็เลือก/ยกเลิกทั้งหมด
    isAllGroupMenuSelected: {
      get() {
        return (
          this.masterGroupMenus.length > 0 &&
          this.selectedGroupMenuIds.length === this.masterGroupMenus.length
        );
      },
      set(value) {
        this.selectedGroupMenuIds = value
          ? this.masterGroupMenus.map((g) => g.id)
          : [];
      },
    },
  },
  watch: {
    checkSameComInv(newVal) {
      this.checkSameComInvChanged(newVal);
    },
    checkSameComInvAdd(newVal) {
      this.checkSameComInvChangedAdd(newVal);
    },
  },
  methods: {
    openAddCom() {
      this.dialogAddCom = true;
    },
    // ⭐ company 1: เปิด dialog แก้ไขแบบ step (มี Menu access)
    openEditNew(item) {
      this.editCompany = { ...item };
      this.dialogEditCom = true;
    },
    // ⭐ บริษัทอื่น: เปิด dialog แก้ไขหน้าเดียว
    openEditBasic(item) {
      this.editCompany = { ...item };
      this.dialogEditBasic = true;
    },
    onDialogAlert({ title, message, color }) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(true, title, message, color);
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    // ⭐ ใหม่: ดึงรายการ group menu ของบริษัทต้นแบบ (Master Template) มาแสดงเป็น checkbox
    async loadMasterGroupMenus() {
      try {
        const res = await getRegisterCompanyMasterTemplate();
        this.masterGroupMenus = res.data || [];
      } catch (error) {
        console.error("loadMasterGroupMenus error:", error);
        this.masterGroupMenus = [];
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async getcompanydata() {
      if (localStorage.getItem(server.ROLE) == "ADMIN") {
        const result = await api.getAllCompany();
        this.desserts = result.data;
      } else {
        const result = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );
        this.desserts = result.data;
      }

      // this.$showLoader();
      this.$hideLoader();
    },

    openadd() {
      this.itemadd = {
        code: "",
        name: "",
        status: "",
      };
      this.dialogadd = true;
    },
    canceladd() {
      this.dialogadd = false;
    },
    cancelAdd() {
      this.dialogAddCom = false;
    },
    canceledit() {
      this.dialogedit = false;
    },
    async savedata() {
      if (this.itemadd.code == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Company Code",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.itemadd.name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Company Name",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.itemadd.status == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Status",
          "text-h5 red--text text-center",
        );
        return;
      }

      let formData = new FormData();
      formData.append("code", this.itemadd.code);
      formData.append("name", this.itemadd.name);
      formData.append("status", this.itemadd.status);
      // formData.append("image", this.itemadd.image);

      if (this.itemadd.image != null || this.itemadd.image != "") {
        formData.append("image", this.itemadd.image);
      }

      // const res_add = await api.addCompany(this.itemadd);
      const res_add = await api.addCompany(formData);
      if (res_add.status == 200 || res_add.status == 201) {
        //   alert("debug1");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Add data success",
          "text-h5 green--text text-center",
        );
        this.getcompanydata();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Add data Failed",
          "text-h5 red--text text-center",
        );
      }
      this.dialogadd = false;
    },

    async openeditItem(item) {
      this.itemeditid = item.id;
      this.itemedit.code = item.code || "";
      this.itemedit.name = item.name || "";
      this.itemedit.company_address = item.company_address || "";
      this.itemedit.company_branch = item.company_branch || "";
      this.itemedit.company_email = item.company_email || "";
      this.itemedit.company_tel = item.company_tel || "";
      this.itemedit.inv_company_name = item.inv_company_name || "";
      this.itemedit.inv_company_name_th = item.inv_company_name_th || "";
      this.itemedit.inv_company_address = item.inv_company_address || "";
      this.itemedit.inv_company_branch = item.inv_company_branch || "";
      this.itemedit.inv_company_email = item.inv_company_email || "";
      this.itemedit.inv_company_tel = item.inv_company_tel || "";
      this.itemedit.inv_tax_id = item.inv_tax_id || "";
      this.itemedit.status = item.status || "";
      this.itemedit.company_address2 = item.company_address2 || "";
      this.itemedit.subdistrict = item.subdistrict || "";
      this.itemedit.district = item.district || "";
      this.itemedit.province = item.province || "";
      this.itemedit.postcode = item.postcode || "";
      this.itemedit.country = item.country || "";
      this.itemedit.inv_company_address2 = item.inv_company_address2 || "";
      this.itemedit.inv_subdistrict = item.inv_subdistrict || "";
      this.itemedit.inv_district = item.inv_district || "";
      this.itemedit.inv_province = item.inv_province || "";
      this.itemedit.inv_postcode = item.inv_postcode || "";
      this.itemedit.inv_country = item.inv_country || "";

      if (item.image != null) {
        // this.itemedit.image = item.image;
        this.image_link = imageUrl + "/" + item.image;
      } else {
        this.image_link = imageUrl + "/personal.png";
        // this.itemedit.image = null;
      }
      // alert(this.image_link);
      // this.itemedit.image = item.image;
      this.itemdocedit = {
        module: "Employee",
        id_prefix: "",
        running_year: new Date()
          .getFullYear()
          .toString()
          .slice(-2),
        running_len: 1,
        running_next: 1,
        doc_status: 0,
      };

      this.$showLoader();
      const resDoc = await api.fineDocRunningByModlue("Employee", item.id);
      console.log("resDoc.data[0]");
      console.log(resDoc.data);
      if (resDoc.data) {
        this.itemdocedit = {
          module: resDoc.data.module,
          id_prefix: resDoc.data.id_prefix,
          running_year: resDoc.data.running_year,
          running_len: resDoc.data.running_len,
          running_next: resDoc.data.running_next,
          doc_status: resDoc.data.check_doc_auto,
        };
      }
      this.$hideLoader();
      this.dialogedit = true;
    },
    fillTestData() {
      Object.assign(this, {
        Firstname: "สมชาย",
        Lastname: "ใจดี",
        Email: "somchai.test@example.com",
        Username: "somchai01",
        Password: "Test1234",
        Confirm_Password: "Test1234",
        User_Telephone_Number: "0812345678",
      });

      Object.assign(this.itemAddCom, {
        // Company
        name: "บริษัท ทดสอบ จำกัด",
        company_address: "123 ถนนทดสอบ",
        company_address2: "ชั้น 5",
        subdistrict: "คลองตัน",
        district: "คลองเตย",
        province: "กรุงเทพมหานคร",
        postcode: "10110",
        country: "Thailand",
        company_branch: "สำนักงานใหญ่",
        company_email: "company.test@example.com",
        company_tel: "021234567",
        code: "TEST01",

        // Invoice
        inv_company_name: "Test Company Co., Ltd.",
        inv_company_name_th: "บริษัท ทดสอบ จำกัด",
        inv_company_address: "123 Test Road",
        inv_company_address2: "5th Floor",
        inv_subdistrict: "คลองตัน",
        inv_district: "คลองเตย",
        inv_province: "กรุงเทพมหานคร",
        inv_postcode: "10110",
        inv_country: "Thailand",
        inv_company_branch: "สำนักงานใหญ่",
        inv_company_email: "invoice.test@example.com",
        inv_company_tel: "021234568",
        inv_tax_id: "1234567890123",

        // Running/Doc settings
        id_prefix: "EMP",
        running_year: "2569",
        running_len: 4,
        running_next: 1,
        doc_status: 1,
      });

      this.selectedGroupMenuIds = [];

      // สุ่ม suffix ตรงนี้ให้อีเมล/รหัสบริษัทไม่ชนกันทุกครั้งที่กดทดสอบ
      const rand = Math.floor(Math.random() * 9999);
      this.Email = `somchai.test${rand}@example.com`;
      this.itemAddCom.company_email = `company.test${rand}@example.com`;
      this.itemAddCom.inv_company_email = `invoice.test${rand}@example.com`;
      this.itemAddCom.code = `T${rand}`.slice(0, 6);
    },
    async savedataAdd() {
      //mocupdata ทดสอบ
      // this.fillTestData()
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const telRegex = /^[+]?([0-9,-]+)$/;

      const fail = (msg, ref) => {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", msg, "text-h5 red--text text-center");
        this.$refs[ref].focus();
      };

      const com = this.itemAddCom;

      // ลำดับการตรวจสอบเหมือนโค้ดเดิมทุกจุด (บางอันเป็น async)
      const checks = [
        { test: () => this.Firstname.trim() !== "", ref: "Firstname", msg: "Please Check Firstname Data" },
        { test: () => this.Lastname.trim() !== "", ref: "Lastname", msg: "Please Check Lastname Data" },
        { test: () => emailRegex.test(this.Email.trim()), ref: "Email", msg: "Please Check Email Data" },
        {
          test: async () => (await api.getUserByEmail(this.Email.trim())).data.length === 0,
          ref: "Email",
          msg: "Email Duplicated, Please Check Email",
        },
        { test: () => this.Username.trim() !== "", ref: "Username", msg: "Please Check Username Data" },
        { test: () => this.Password.trim() !== "", ref: "Password", msg: "Please Check Password Data" },
        { test: () => this.Confirm_Password.trim() !== "", ref: "Confirm_Password", msg: "Please Check Confirm Password Data" },
        {
          test: () => this.User_Telephone_Number != "" && this.User_Telephone_Number != null,
          ref: "user_phone",
          msg: "กรุณากรอกเบอร์โทรศัพท์",
        },
        {
          test: async () => {
            if (!this.User_Telephone_Number) return true; // ไม่มีเบอร์ ไม่ต้องเช็ค
            const res = await api.getUserByPhoneComID(
              this.User_Telephone_Number,
              localStorage.getItem(server.COMPANYID),
            );
            return res.data.length === 0;
          },
          ref: "user_phone",
          msg: "เบอร์โทรศัพท์นี้ถูกใช้งานแล้ว กรุณาตรวจสอบเบอร์โทรศัพท์",
        },
        { test: () => this.Password.trim() === this.Confirm_Password.trim(), ref: "Confirm_Password", msg: "Please Check Password and Confirm Password" },

        { test: () => com.name.trim() !== "", ref: "Company_Name_Add", msg: "Please Check Company Name Data" },
        { test: () => com.company_address.trim() !== "", ref: "Company_Address_Add", msg: "Please check the company information again." },
        { test: () => com.subdistrict.trim() !== "", ref: "subdistrict", msg: "Please check the company information again." },
        { test: () => com.district.trim() !== "", ref: "district", msg: "Please check the company information again." },
        { test: () => com.province.trim() !== "", ref: "province", msg: "Please check the company information again." },
        { test: () => com.postcode.trim() !== "", ref: "postcode", msg: "Please check the company information again." },
        { test: () => com.country.trim() !== "", ref: "country", msg: "Please check the company information again." },
        { test: () => com.company_branch.trim() !== "", ref: "Company_Branch_Add", msg: "Please Check Branch Data" },
        { test: () => emailRegex.test(com.company_email.trim()), ref: "Company_Email_Add", msg: "Please Check Company Email Data" },
        {
          test: async () => (await api.getCompanyCol(com.company_email, "company_email")).data.length === 0,
          ref: "Company_Email_Add",
          msg: "Email Duplicated, Please Check Email",
        },
        { test: () => telRegex.test(com.company_tel), ref: "Company_Telephone_Number_Add", msg: "Please Check Telephone Number Data" },
        { test: () => com.code.trim() !== "" && com.code.length <= 6, ref: "Company_Code_Add", msg: "Please Check Company Code Data" },

        { test: () => com.inv_company_name.trim() !== "", ref: "INV_Company_Name_Add", msg: "Please Check Company Name Data" },
        { test: () => com.inv_company_name_th.trim() !== "", ref: "INV_Company_Name_TH_Add", msg: "Please Check Company Name Thai Data" },
        { test: () => com.inv_company_address.trim() !== "", ref: "Invoice_Address_Add", msg: "Please check the invoice information again." },
        { test: () => com.inv_subdistrict.trim() !== "", ref: "inv_subdistrict", msg: "Please check the invoice information again." },
        { test: () => com.inv_district.trim() !== "", ref: "inv_district", msg: "Please check the invoice information again." },
        { test: () => com.inv_province.trim() !== "", ref: "inv_province", msg: "Please check the invoice information again." },
        { test: () => com.inv_postcode.trim() !== "", ref: "inv_postcode", msg: "Please check the invoice information again." },
        { test: () => com.inv_country.trim() !== "", ref: "inv_country", msg: "Please check the invoice information again." },
        { test: () => com.inv_company_branch.trim() !== "", ref: "INV_Branch_Add", msg: "Please Check Branch Data" },
        { test: () => emailRegex.test(com.inv_company_email.trim()), ref: "INV_Email_Add", msg: "Please Check Company Email Data" },
        {
          test: async () => (await api.getCompanyCol(com.inv_company_email, "inv_company_email")).data.length === 0,
          ref: "INV_Email_Add",
          msg: "Email Duplicated, Please Check Email",
        },
        { test: () => telRegex.test(com.inv_company_tel), ref: "INV_Telephone_Number_Add", msg: "Please Check Telephone Number Data" },
        { test: () => com.inv_tax_id.trim() !== "", ref: "INV_Tax_ID_Add", msg: "Please Check Tax ID Data" },

        {
          test: async () => (await api.getCompanyByComCode(com.code.trim())).data.length === 0,
          ref: "Company_Code_Add",
          msg: "Company Code Duplicated, Please Check Company Code",
          onFail: () => { this.checkDialogRegister = 1; },
        },
      ];

      for (const c of checks) {
        if (!(await c.test())) {
          if (c.onFail) c.onFail();
          fail(c.msg, c.ref);
          return;
        }
      }

      if (com.doc_status == 0) {
        if (com.running_len < 1) return fail("Please Check Range Data", "Range");
        if (com.running_next < 1) return fail("Please Check Next Running Data", "Next Running");
      }

      // console.log(this.itemAddCom)
      var item_data = {
        Firstname: this.Firstname.trim(),
        Lastname: this.Lastname.trim(),
        // Date_of_Birth:  this.Date_of_Birth,
        User_Telephone_Number: this.User_Telephone_Number,
        Email: this.Email.trim(),
        Username: this.Username.trim(),
        Password: this.Password.trim(),
        Confirm_Password: this.Confirm_Password.trim(),
        //company
        Company_Name: this.itemAddCom.name.trim(),
        Company_Address: this.itemAddCom.company_address.trim(),
        Company_Branch: this.itemAddCom.company_branch.trim(),
        Company_Email: this.itemAddCom.company_email.trim(),
        Company_Telephone_Number: this.itemAddCom.company_tel.trim(),
        Company_Code: this.itemAddCom.code.trim(),
        //INV
        INV_Company_Name: this.itemAddCom.inv_company_name.trim(),
        INV_Company_Name_TH: this.itemAddCom.inv_company_name_th.trim(),
        Invoice_Address: this.itemAddCom.inv_company_address.trim(),
        INV_Branch: this.itemAddCom.inv_company_branch.trim(),
        INV_Email: this.itemAddCom.inv_company_email.trim(),
        INV_Telephone_Number: this.itemAddCom.inv_company_tel.trim(),
        INV_Tax_ID: this.itemAddCom.inv_tax_id.trim(),
        module: "Employee",
        id_prefix: this.itemAddCom.id_prefix,
        running_year: this.itemAddCom.running_year,
        running_len: this.itemAddCom.running_len,
        running_next: this.itemAddCom.running_next,
        doc_status: this.itemAddCom.doc_status,

        company_address2: this.itemAddCom.company_address2,
        subdistrict: this.itemAddCom.subdistrict,
        district: this.itemAddCom.district,
        province: this.itemAddCom.province,
        postcode: this.itemAddCom.postcode,
        country: this.itemAddCom.country,

        inv_company_address2: this.itemAddCom.inv_company_address2,
        inv_subdistrict: this.itemAddCom.inv_subdistrict,
        inv_district: this.itemAddCom.inv_district,
        inv_province: this.itemAddCom.inv_province,
        inv_postcode: this.itemAddCom.inv_postcode,
        inv_country: this.itemAddCom.inv_country,

        // ⭐ ใหม่: กลุ่มเมนูที่เลือกไว้ (clone จากบริษัทต้นแบบ) — ถ้าไม่เลือกเลย
        // backend จะ clone ให้ครบทุกกลุ่มโดยอัตโนมัติ (พฤติกรรมเดิม)
        group_menu_ids: JSON.stringify(this.selectedGroupMenuIds),
      };
      this.$showLoader();
      const res_add_com = await api.addRegsiterCompany(item_data);
      if (res_add_com.status == 201) {
        this.$hideLoader();
        this.dialogAddCom = false;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
        );
        return;
      } else {
        this.$hideLoader();
        this.dialogAddCom = false;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Information Save failed",
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    async savedataedit() {
      if (this.$refs.form.validate()) {
        if (this.itemedit.name.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Company Name Data",
            "text-h5 red--text text-center",
          );
          this.$refs["Company_Name"].focus();
          return;
        }
        if (this.itemedit.company_address.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["Company_Address"].focus();
          return;
        }
        if (this.itemedit.subdistrict.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the company information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_subdistrict"].focus();
          return;
        }
        if (this.itemedit.district.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the company information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_district"].focus();
          return;
        }
        if (this.itemedit.province.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the company information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_province"].focus();
          return;
        }
        if (this.itemedit.postcode.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the company information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_postcode"].focus();
          return;
        }
        if (this.itemedit.country.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the company information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_country"].focus();
          return;
        }
        if (this.itemedit.company_branch.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Branch Data",
            "text-h5 red--text text-center",
          );
          this.$refs["Company_Branch"].focus();
          return;
        }
        if (this.itemedit.company_email.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Company Email Data",
            "text-h5 red--text text-center",
          );
          this.$refs["Company_Email"].focus();
          return;
        }
        if (this.itemedit.company_tel.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Telephone Number Data",
            "text-h5 red--text text-center",
          );
          this.$refs["Company_Telephone_Number"].focus();
          return;
        }

        if (this.itemedit.code.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Company Code Data",
            "text-h5 red--text text-center",
          );
          this.$refs["Company_Code"].focus();
          return;
        }
        if (this.itemedit.inv_company_name.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Company Name Data",
            "text-h5 red--text text-center",
          );
          this.$refs["INV_Company_Name"].focus();
          return;
        }
        if (this.itemedit.inv_company_name_th.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Company Name Thai Data",
            "text-h5 red--text text-center",
          );
          this.$refs["INV_Company_Name_TH"].focus();
          return;
        }
        if (this.itemedit.inv_company_address.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["Invoice_Address"].focus();
          return;
        }
        if (this.itemedit.inv_subdistrict.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_inv_subdistrict"].focus();
          return;
        }
        if (this.itemedit.inv_district.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_inv_district"].focus();
          return;
        }
        if (this.itemedit.inv_province.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_inv_province"].focus();
          return;
        }
        if (this.itemedit.inv_postcode.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_inv_postcode"].focus();
          return;
        }
        if (this.itemedit.inv_country.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check the invoice information again.",
            "text-h5 red--text text-center",
          );
          this.$refs["edit_inv_country"].focus();
          return;
        }
        if (this.itemedit.inv_company_branch.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Branch Data",
            "text-h5 red--text text-center",
          );
          this.$refs["INV_Branch"].focus();
          return;
        }
        if (this.itemedit.inv_company_email.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Company Email Data",
            "text-h5 red--text text-center",
          );
          this.$refs["INV_Email"].focus();
          return;
        }
        if (this.itemedit.inv_company_tel.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Telephone Number Data",
            "text-h5 red--text text-center",
          );
          this.$refs["INV_Telephone_Number"].focus();
          return;
        }
        if (this.itemedit.inv_tax_id.trim() == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Check Tax ID Data",
            "text-h5 red--text text-center",
          );
          this.$refs["INV_Tax_ID"].focus();
          return;
        }

        if (this.itemdocedit.doc_status == 0) {
          if (this.itemdocedit.running_len < 1) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please Check Range Data",
              "text-h5 red--text text-center",
            );
            this.$refs["Range Edit"].focus();
            return;
          }
          if (this.itemdocedit.running_next < 1) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please Check Next Running Data",
              "text-h5 red--text text-center",
            );
            this.$refs["Next Running Edit"].focus();
            return;
          }
        }

        let formData = new FormData();
        formData.append("name", this.itemedit.name);
        formData.append("company_address", this.itemedit.company_address);
        formData.append("company_branch", this.itemedit.company_branch);
        formData.append("company_email", this.itemedit.company_email);
        formData.append("company_tel", this.itemedit.company_tel);
        formData.append("inv_company_name", this.itemedit.inv_company_name);
        formData.append(
          "inv_company_name_th",
          this.itemedit.inv_company_name_th,
        );
        formData.append(
          "inv_company_address",
          this.itemedit.inv_company_address,
        );
        formData.append("inv_company_branch", this.itemedit.inv_company_branch);
        formData.append("inv_company_email", this.itemedit.inv_company_email);
        formData.append("inv_company_tel", this.itemedit.inv_company_tel);
        formData.append("inv_tax_id", this.itemedit.inv_tax_id);
        formData.append("status", this.itemedit.status);

        formData.append("company_address2", this.itemedit.company_address2);
        formData.append("subdistrict", this.itemedit.subdistrict);
        formData.append("district", this.itemedit.district);
        formData.append("province", this.itemedit.province);
        formData.append("postcode", this.itemedit.postcode);
        formData.append("country", this.itemedit.country);

        formData.append(
          "inv_company_address2",
          this.itemedit.inv_company_address2,
        );
        formData.append("inv_subdistrict", this.itemedit.inv_subdistrict);
        formData.append("inv_district", this.itemedit.inv_district);
        formData.append("inv_province", this.itemedit.inv_province);
        formData.append("inv_postcode", this.itemedit.inv_postcode);
        formData.append("inv_country", this.itemedit.inv_country);

        if (this.itemedit.image != null || this.itemedit.image != "") {
          formData.append("image", this.itemedit.image);
        }

        // const res_update = await api.updateCompany(
        //   this.itemeditid,
        //   this.itemedit
        // );
        this.$showLoader();
        const res_update = await api.updateCompany(this.itemeditid, formData);
        const res_doc = await api.updateDocRunningCom(
          this.itemeditid,
          this.itemdocedit,
        );
        this.$hideLoader();
        console.log(res_update);
        if (res_update.status == 200 || res_update.status == 201) {
          //   alert("debug1");
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Update data success",
            "text-h5 green--text text-center",
          );
          this.getcompanydata();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Update data Failed",
            "text-h5 red--text text-center",
          );
        }
        this.dialogedit = false;
      }
    },
    async checkSameComInvChangedAdd(value) {
      if (value) {
        this.itemAddCom.inv_company_name = this.itemAddCom.name.trim();
        this.itemAddCom.inv_company_address = this.itemAddCom.company_address.trim();
        this.itemAddCom.inv_company_branch = this.itemAddCom.company_branch.trim();
        this.itemAddCom.inv_company_email = this.itemAddCom.company_email.trim();
        this.itemAddCom.inv_company_tel = this.itemAddCom.company_tel.trim();
        this.itemAddCom.inv_company_address2 = this.itemAddCom.company_address2.trim();
        this.itemAddCom.inv_subdistrict = this.itemAddCom.subdistrict.trim();
        this.itemAddCom.inv_district = this.itemAddCom.district.trim();
        this.itemAddCom.inv_province = this.itemAddCom.province.trim();
        this.itemAddCom.inv_postcode = this.itemAddCom.postcode.trim();
        this.itemAddCom.inv_country = this.itemAddCom.country.trim();
      } else {
        this.itemAddCom.inv_company_name = "";
        this.itemAddCom.inv_company_address = "";
        this.itemAddCom.inv_company_branch = "";
        this.itemAddCom.inv_company_email = "";
        this.itemAddCom.inv_company_tel = "";
        this.itemAddCom.inv_company_address2 = "";
        this.itemAddCom.inv_subdistrict = "";
        this.itemAddCom.inv_district = "";
        this.itemAddCom.inv_province = "";
        this.itemAddCom.inv_postcode = "";
        this.itemAddCom.inv_country = "";
      }
    },
    async checkSameComInvChanged(value) {
      if (value) {
        this.itemedit.inv_company_name = this.itemedit.name.trim();
        this.itemedit.inv_company_address = this.itemedit.company_address.trim();
        this.itemedit.inv_company_branch = this.itemedit.company_branch.trim();
        this.itemedit.inv_company_email = this.itemedit.company_email.trim();
        this.itemedit.inv_company_tel = this.itemedit.company_tel.trim();
        this.itemedit.inv_company_address2 = this.itemedit.company_address2.trim();
        this.itemedit.inv_subdistrict = this.itemedit.subdistrict.trim();
        this.itemedit.inv_district = this.itemedit.district.trim();
        this.itemedit.inv_province = this.itemedit.province.trim();
        this.itemedit.inv_postcode = this.itemedit.postcode.trim();
        this.itemedit.inv_country = this.itemedit.country.trim();
      } else {
        this.itemedit.inv_company_name = "";
        this.itemedit.inv_company_address = "";
        this.itemedit.inv_company_branch = "";
        this.itemedit.inv_company_email = "";
        this.itemedit.inv_company_tel = "";
        this.itemedit.inv_company_address2 = "";
        this.itemedit.inv_subdistrict = "";
        this.itemedit.inv_district = "";
        this.itemedit.inv_province = "";
        this.itemedit.inv_postcode = "";
        this.itemedit.inv_country = "";
      }
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>